import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

function createWrapperAndAppendToBody(wrapperId) {
  const wrapperElement = document.createElement('div');
  wrapperElement.setAttribute('id', wrapperId);
  document.body.appendChild(wrapperElement);
  return wrapperElement;
}

const RawStackModal = ({
  ModalStore: { modals, removeModal },
  modalID,
  children,
}) => {
  const wrapperId = 'stackModalWrapper';
  const [wrapperElement, setWrapperElement] = useState(null);

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId);
    let systemCreated = false;
    if (!element) {
      systemCreated = true;
      element = createWrapperAndAppendToBody(wrapperId);
    }
    setWrapperElement(element);

    return () => {
      // delete the programatically created element
      if (systemCreated && element.parentNode) {
        element.parentNode.removeChild(element);
      }
      removeModal(modalID);
    };
  }, []);

  if (wrapperElement === null) return null;

  if (modals[modals.length - 1] !== modalID) return null;

  return createPortal(<ModalContent>{children}</ModalContent>, wrapperElement);
};

export const STACK_MODAL_Z_INDEX = 2147483644;

const Wrapper = styled.div`
  z-index: ${STACK_MODAL_Z_INDEX};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

const ModalContent = ({ children }) => {
  useLayoutEffect(() => {
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.documentElement.style.overflow = 'auto';
    };
  }, []);
  return <Wrapper>{children}</Wrapper>;
};

export const StackModal = inject('ModalStore')(observer(RawStackModal));
